// extracted by css-extract-rspack-plugin
export default {"navBar":"translucent-nav-bar_navBar__XORl7","bg":"translucent-nav-bar_bg__-JgGQ"};